import axios from "axios";

const apiClient = axios.create({
  baseURL: "https://api.fantasylineups.com/",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export default {
  saveLastLineup(params) {
    return apiClient.post("user/saveLastLineup", params);
  },

  fetchLastLineup(params) {
    return apiClient.post("user/getLastLineup", params);
  },

  setProjection(params) {
    return apiClient.post("user/setProjection", params);
  },

  fetchProcessInfo() {
    return axios.get("https://api.fantasylineups.com/user/getServerDetails");
  },

  userLastActivity(params) {
    return apiClient.post("user/getUserLastLineup", params);
  },

  cancelSubscription(params) {
    return apiClient.post("user/cancelSubscription", params);
  },

  getReport() {
    return apiClient.get("user/getAllnewuser");
  },

  getIp() {
    return axios.get("https://api.ipify.org/?format=json");
  },

  getRegion(params) {
    return axios.get(`https://ipapi.co/${params}/region/`);
  },

  createSessionwithoutTrial(params) {
    return apiClient.post("user/createsessionwithoutrial", params);
  },

  getUserStatus(params) {
    return apiClient.post("user/userStatus", params);
  },

  getRevenueData(params) {
    return axios.post(
      "https://apietherapy.kushubmedia.com/counselor/stripe/null",
      params
    );
  },

  SubmitCsvProjection(params) {
    return apiClient.post("user/submitCsvProjection", params);
  },

  checkTodayLineup(params) {
    return apiClient.post("user/getTodayLineup", params);
  },

  sendVerifyEmail(params) {
    return apiClient.post("user/sendVerifyEmail", params);
  },

  verifyEmail(params) {
    return apiClient.post("user/verifyEmail", params);
  },

  userLoginData(params) {
    return apiClient.post("user/getLoginData", params);
  },

  saveUserBestBet(params) {
    return apiClient.post("user/saveBestBet", params);
  },

  saveUserBestBetProps(params) {
    return apiClient.post("user/saveBestBetProps", params);
  },

  getBestBet(params) {
    return apiClient.post("user/getBestBet", params);
  },

  getBestBetProps(params) {
    return apiClient.post("user/getBestBetProps", params);
  },

  setBuildExposure(params) {
    return apiClient.post("user/getExposure", params);
  },

  getTeamNews(params) {
    return apiClient.post("user/getTeamNews", params);
  },

  getPlayerFullStats(params) {
    return apiClient.post("mlb/playerDetails", params);
  },

  getPlayerScore(params) {
    return apiClient.post("user/getPlayerScore", params);
  },

  getPlayerSeasonStats(params) {
    return apiClient.post("user/getPlayerSeasonStats", params);
  },

  getPlayerNews(params) {
    return apiClient.post("user/getPlayerNews", params);
  },

  createFreeSub(params) {
    return apiClient.post("user/createFreeSubscription", params);
  },
};
